/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseCategoryDto
 */
export interface CaseCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CaseCategoryDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseCategoryDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseCategoryDto
     */
    description?: string;
}

/**
 * Check if a given object implements the CaseCategoryDto interface.
 */
export function instanceOfCaseCategoryDto(value: object): value is CaseCategoryDto {
    return true;
}

export function CaseCategoryDtoFromJSON(json: any): CaseCategoryDto {
    return CaseCategoryDtoFromJSONTyped(json, false);
}

export function CaseCategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseCategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CaseCategoryDtoToJSON(json: any): CaseCategoryDto {
    return CaseCategoryDtoToJSONTyped(json, false);
}

export function CaseCategoryDtoToJSONTyped(value?: CaseCategoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'displayName': value['displayName'],
        'description': value['description'],
    };
}

